/**
 * useFilterPopover — state chung cho popover Filter (Search / Vendor / Status...).
 *
 * Replace pattern lặp ở 26 page:
 *   const [filterPopover, setFilterPopover] = useState<{kind, anchor} | null>(null)
 *   const openFilterPopover = (kind, e) => setFilterPopover({kind, anchor: e.currentTarget})
 *   const closeFilterPopover = () => setFilterPopover(null)
 */
import { type MouseEvent, useCallback, useState } from 'react'

export interface FilterPopoverState<K extends string> {
  kind: K
  anchor: HTMLElement
}

export interface UseFilterPopoverResult<K extends string> {
  state: FilterPopoverState<K> | null
  open: (kind: K, event: MouseEvent<HTMLElement>) => void
  close: () => void
  isOpen: (kind: K) => boolean
}

export function useFilterPopover<K extends string>(): UseFilterPopoverResult<K> {
  const [state, setState] = useState<FilterPopoverState<K> | null>(null)

  const open = useCallback((kind: K, event: MouseEvent<HTMLElement>) => {
    setState({ kind, anchor: event.currentTarget })
  }, [])

  const close = useCallback(() => setState(null), [])

  const isOpen = useCallback((kind: K) => state?.kind === kind, [state])

  return { state, open, close, isOpen }
}
